import BaseModel from '@/models/BaseModel';

export default class LoginForm extends BaseModel {
    get fieldList() {
        return ['email', 'password'];
    }

    get rules() {
        return {
            email: [
                {
                    required: true,
                    message: 'Введите логин для входа',
                    trigger: 'change'
                }
            ],
            password: [
                {
                    required: true,
                    message: 'Введите пароль',
                    trigger: 'change'
                }
            ]
        };
    }

    get attributeLabels() {
        return {
            email: 'E-mail',
            password: 'Пароль'
        };
    }
}
